import LoginRoutes from '@/routes/loginRoute';
import DashboardRoutes from '@/routes/dashboardRoute';
import LandingPageRoutes from '@/routes/landingPageRoute';
import PrivacyPolicyRoutes from '@/routes/privacyPolicyRoute';

export default({
  LoginRoutes,
  DashboardRoutes,
  LandingPageRoutes,
  PrivacyPolicyRoutes
});
